import React from 'react';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
import { useLanguage } from '../i18n/LanguageContext';
interface PublicOfferPageProps {
  onNavigate: (page: string) => void;
}
export function PublicOfferPage({
  onNavigate
}: PublicOfferPageProps) {
  const {
    t
  } = useLanguage();
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-26752">
      <div className="bg-white border-b border-slate-200 pt-6 pb-12" data-id="element-26753">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26754">
          <Breadcrumbs items={[{
          label: t('legal.backToHome'),
          onClick: () => onNavigate('home')
        }, {
          label: t('legal.offer.title')
        }]} className="mb-8" data-id="element-26755" />
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-26756">
            {t('legal.offer.title')}
          </h1>
          <p className="text-slate-500" data-id="element-26757">{t('legal.lastUpdated')}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-26758">
        <div className="bg-white rounded-2xl p-8 sm:p-12 border border-slate-200 shadow-sm prose prose-slate max-w-none" data-id="element-26759">
          <h2 data-id="element-26760">{t('legal.offer.s1.title')}</h2>
          <p data-id="element-26761">{t('legal.offer.s1.p1')}</p>

          <h2 data-id="element-26762">{t('legal.offer.s2.title')}</h2>
          <p data-id="element-26763">{t('legal.offer.s2.p1')}</p>

          <h2 data-id="element-26764">{t('legal.offer.s3.title')}</h2>
          <p data-id="element-26765">{t('legal.offer.s3.p1')}</p>

          <h2 data-id="element-26766">{t('legal.offer.s4.title')}</h2>
          <p data-id="element-26767">{t('legal.offer.s4.p1')}</p>

          <h2 data-id="element-26768">{t('legal.offer.s5.title')}</h2>
          <p data-id="element-26769">{t('legal.offer.s5.p1')}</p>

          <h2 data-id="element-26770">{t('legal.offer.s6.title')}</h2>
          <p data-id="element-26771">{t('legal.offer.s6.p1')}</p>

          <h2 data-id="element-26772">{t('legal.offer.s7.title')}</h2>
          <p data-id="element-26773">{t('legal.offer.s7.p1')}</p>

          <h2 data-id="element-26774">{t('legal.offer.s8.title')}</h2>
          <p data-id="element-26775">{t('legal.offer.s8.p1')}</p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm" data-id="element-26776">
          <button onClick={() => onNavigate('terms')} className="text-indigo-600 hover:text-indigo-800 font-medium transition-colors" data-id="element-26777">
            {t('legal.terms.title')} →
          </button>
          <button onClick={() => onNavigate('contact')} className="text-slate-500 hover:text-slate-700 font-medium transition-colors" data-id="element-26778">
            {t('legal.contactUs')}
          </button>
        </div>
      </div>
    </div>;
}